<template>
    <div class="animated fadeIn">
        <b-card v-if="canAccessLaporanSalesRetur || canAccessLaporanSalesReturEmas">
            <h5 class="mb-0"><i class="fa fa-fw fa-book mr-2" />Laporan Sales & Retur (Emas & Elektronik)</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Tgl. Mulai Laporan">
                        <b-form-input type="date" v-model="inputSales.start" :max="inputSales.end" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Tgl. Akhir Laporan">
                        <b-form-input type="date" v-model="inputSales.end" :min="inputSales.start" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Filter Berdasarkan">
                        <b-form-select v-model="inputSales.dateType" :options="dateTypeOptions" />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button v-if="canAccessLaporanSalesRetur" variant="dark" class="mr-2 mb-2"
                    @click="generateReportSales">
                    <i class="fa fa-download mr-2" />Laporan Sales & Retur Barang
                </b-button>
                <b-button v-if="canAccessLaporanSalesReturEmas" variant="dark" class="mr-2 mb-2 button-gold"
                    @click="generateReportSalesGold">
                    <i class="fa fa-download mr-2" />Laporan Sales & Retur Emas
                </b-button>
            </div>
        </b-card>

        <b-card>
            <h5 class="mb-0"><i class="fa fa-fw fa-book mr-2" />Laporan</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Tgl. Mulai Laporan">
                        <b-form-input type="date" v-model="input.start"  :max="input.end"/>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Tgl. Akhir Laporan">
                        <b-form-input type="date" v-model="input.end" :min="input.start" />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button v-if="canAccessLaporanTransaksiCustomer" variant="dark" class="mr-2 mb-2"
                    @click="generateReportTransaction">
                    <i class="fa fa-download mr-2" />Laporan Transaksi Customer
                </b-button>
                <b-button v-if="canAccessLaporanTransaksiPembayaran" variant="dark" class="mr-2 mb-2"
                    @click="generateReportTransactionPayment">
                    <i class="fa fa-download mr-2" />Laporan Transaksi Pembayaran
                </b-button>
                <b-button v-if="canAccessLaporanPenerimaanBarang" variant="dark" class="mr-2 mb-2"
                    @click="generateDeliveryReport">
                    <i class="fa fa-download mr-2" />Laporan Penerimaan Barang
                </b-button>
                <b-button v-if="canAccessLaporanPenerimaanBarangExternal" variant="dark" class="mr-2 mb-2"
                    @click="generateInventoryExternal">
                    <i class="fa fa-download mr-2" /> Laporan Penerimaan Barang External
                </b-button>
                <b-button v-if="canAccessLaporanPerpindahanBarang" variant="dark" class="mr-2 mb-2"
                    @click="generateMovementReport">
                    <i class="fa fa-download mr-2" />Laporan Perpindahan Barang
                </b-button>
                <b-button v-if="canAccessLaporanCatalogCustomer" variant="dark" class="mr-2 mb-2"
                    @click="generateCatalogCustomerLoginReport">
                    <i class="fa fa-download mr-2" />Laporan Catalog Customer
                </b-button>
                <b-button v-if="canAccessLaporanTugasAdmin" variant="dark" class="mr-2 mb-2"
                    @click="generateAdminTaskCountReport">
                    <i class="fa fa-download mr-2" />Laporan Tugas Admin
                </b-button>
                <b-button v-if="canAccessLaporanKirimBalikPGI" variant="dark" class="mr-2 mb-2"
                    @click="generateInventoryReturnReport">
                    <i class="fa fa-download mr-2" /> Laporan Kirim Balik PGI
                </b-button>
                <b-button v-if="canAccessLaporanKirimInvenPGI" variant="dark" class="mr-2 mb-2"
                    @click="generateInventoryReport">
                    <i class="fa fa-download mr-2" /> Laporan Kirim Inventaris
                </b-button>
                <b-button v-if="canAccessLaporanAdjustmentBarcode" variant="dark" class="mr-2 mb-2"
                    @click="generateAdjustmentBarcodeReport">
                    <i class="fa fa-download mr-2" /> Laporan Adjustment Barcode
                </b-button>
                <b-button v-if="canAccessLaporanAdjustmentKerusakan" variant="dark" class="mr-2 mb-2"
                    @click="generateDamageAdjustmentReport">
                    <i class="fa fa-download mr-2" /> Laporan Adjustment Kerusakan
                </b-button>
                <b-button v-if="canAccessLaporanTitipJual" variant="dark" class="mr-2 mb-2"
                    @click="generateReportTitipJual">
                    <i class="fa fa-download mr-2" /> Laporan Titip Jual
                </b-button>
                <b-button v-if="canAccessLaporanPenjualanMarketplace" variant="dark" class="mr-2 mb-2"
                    @click="generateReportSalesMarketplace">
                    <i class="fa fa-download mr-2" /> Laporan Sales Marketplace
                </b-button>
                <b-button v-if="canAccessLaporanReturMarketplace" variant="dark" class="mr-2 mb-2"
                    @click="generateReportSalesMarketplaceReturn">
                    <i class="fa fa-download mr-2" /> Laporan Retur Marketplace
                </b-button>
                <b-button v-if="canAccessLaporanSalesAndReturnMarketplace" variant="dark" class="mr-2 mb-2"
                    @click="generateReportSalesAndReturnMarketplace">
                    <i class="fa fa-download mr-2" /> Laporan Sales & Retur Marketplace
                </b-button>
                <b-button v-if="canAccessLaporanInventoryReset" variant="dark" class="mr-2 mb-2"
                    @click="generateInventoryResetReport">
                    <i class="fa fa-download mr-2" /> Laporan Inventory Reset
                </b-button>
                <b-button v-if="canAccessLaporanTemuanElektronik" variant="dark" class="mr-2 mb-2"
                    @click="generateDateRangeReport('Laporan Temuan Elektronik', 'report/inventory-variance')">
                    <i class="fa fa-download mr-2" /> Laporan Temuan Elektronik
                </b-button>
            </div>

            <hr class="divider" />

            <h5 class="mb-0"><i class="fa fa-fw fa-book mr-2" />Laporan Emas</h5>
            <hr />
            <div>
                <b-button v-if="canAccessLaporanPenerimaanBarangEmasPGI" variant="dark" class="mr-2 mb-2 button-gold"
                    @click="generateDeliveryReportGold('PGI')">
                    <i class="fa fa-download mr-2" />Laporan Penerimaan Barang Emas PGI
                </b-button>
                <b-button v-if="canAccessLaporanPenerimaanBarangEmasPEI" variant="dark" class="mr-2 mb-2 button-gold"
                    @click="generateDeliveryReportGold('PEI')">
                    <i class="fa fa-download mr-2" />Laporan Penerimaan Barang Emas PEI
                </b-button>
                <b-button v-if="canAccessLaporanPenerimaanBarangEmasRBE" variant="dark" class="mr-2 mb-2 button-gold"
                    @click="generateDeliveryReportGold('RBE')">
                    <i class="fa fa-download mr-2" />Laporan Penerimaan Barang Emas RBE
                </b-button>
                <b-button v-if="canAccessLaporanPenerimaanBarangExternalEmas" variant="dark"
                    class="mr-2 mb-2 button-gold" @click="generateInventoryGoldExternal">
                    <i class="fa fa-download mr-2" />Laporan Penerimaan Barang External Emas
                </b-button>
                 <b-button v-if="canAccessLaporanSalesGoldDifference" variant="dark" class="mr-2 mb-2 button-gold"
                    @click="generateReportDifferenceGoldSale">
                    <i class="fa fa-download mr-2" /> Laporan Sales Selisih Emas
                </b-button>
                <b-button v-if="canAccessLaporanLeburEmas" variant="dark" class="mr-2 mb-2 button-gold"
                    @click="generateGoldMeltReport">
                    <i class="fa fa-download mr-2" /> Laporan Lebur Emas
                </b-button>
                <b-button v-if="canAccessLaporanTemuanEmas" variant="dark" class="mr-2 mb-2 button-gold"
                    @click="generateDateRangeReport('Laporan Temuan Emas', 'report/gold-variance')">
                    <i class="fa fa-download mr-2" /> Laporan Temuan Emas
                </b-button>
            </div>
        </b-card>

        <b-row>
            <b-col md="6">
                <b-card>
                    <h5 class="mb-0"><i class="fa fa-fw fa-book mr-2" />Laporan Audit</h5>
                    <hr />
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Bulan & Tahun">
                                <b-form-input type="month" v-model="inputAudit.monthYear" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div>
                        <b-button v-if="canAccessLaporanSalesAudit" variant="dark" class="mr-2 mb-2"
                            @click="generateSalesAuditReport">
                            <i class="fa fa-download mr-2" />Laporan Sales Audit
                        </b-button>
                        <b-button v-if="canAccessLaporanSalesAuditEmas" variant="dark" class="mr-2 mb-2 button-gold"
                            @click="generateSalesAuditGoldReport">
                            <i class="fa fa-download mr-2" />Laporan Sales Audit Emas
                        </b-button>
                    </div>
                </b-card>
            </b-col>

            <b-col md="6" v-if="canAccessLaporanStockWarehouse">
                <b-card>
                    <h5 class="mb-0"><i class="fa fa-fw fa-book mr-2" />Laporan Stok Gudang</h5>
                    <hr />
                    <div>
                        <b-button variant="dark" class="mr-2 mb-2" @click="generateWarehouseStock">
                            <i class="fa fa-download mr-2" />Laporan Stok Gudang
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <b-modal id="m-download"
            :title="modalTitle"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
            ref="downloadModal"
        >
            <template #modal-title>
                {{ modalTitle }}
                <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    :disabled="status == 0"
                    @click="$refs.downloadModal.hide()"
                    style="position: absolute; top: 0.5rem; right: 1rem;">
                    <b-spinner small v-if="status == 0" />
                    <span v-else aria-hidden="true">&times;</span>
                </button>
            </template>
            <div v-if="status == 0">
                Menyiapkan laporan, mohon menunggu...
            </div>
            <div v-else-if="status == -1">
                Gagal menyiapkan laporan. Silahkan coba lagi, atau perpendek jarak antara tanggal mulai dan selesai
                laporan!
            </div>
            <div v-else>
                Laporan sudah siap. Tekan tombol dibawah ini untuk download laporan Excel.
                <div class="mt-2">
                    <a :href="path" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Excel Laporan
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EnumPermissions from "@/shared/enum-permissions";

export default {
    data() {
        return {

            status: 1, // 1: sukses, 0: loading, -1: error
            path: "",
            modalTitle: "",

            input: {
                start: "",
                end: ""
            },

            inputSales: {
                start: "",
                end: "",
                dateType: "sold_at"
            },

            dateTypeOptions: [
                { value: "sold_at", text: "Tanggal Penjualan" },
                { value: "confirmed_at", text: "Tanggal Transaksi" }
            ],

            inputAudit: {
                monthYear: ""
            }

        }
    },
    computed: {
        // Laporan Biasa
        canAccessLaporanSalesRetur() {
            return this.hasPermission(EnumPermissions.LAPORAN_SALES_RETUR_BARANG);
        },
        canAccessLaporanTransaksiCustomer() {
            return this.hasPermission(EnumPermissions.LAPORAN_TRANSAKSI_CUSTOMER);
        },
        canAccessLaporanTransaksiPembayaran() {
            return this.hasPermission(EnumPermissions.LAPORAN_TRANSAKSI_PEMBAYARAN);
        },
        canAccessLaporanPenerimaanBarang() {
            return this.hasPermission(EnumPermissions.LAPORAN_PENERIMAAN_BARANG);
        },
        canAccessLaporanPenerimaanBarangExternal() {
            return this.hasPermission(EnumPermissions.LAPORAN_PENERIMAAN_BARANG_EXTERNAL);
        },
        canAccessLaporanPerpindahanBarang() {
            return this.hasPermission(EnumPermissions.LAPORAN_PERPINDAHAN_BARANG);
        },
        canAccessLaporanCatalogCustomer() {
            return this.hasPermission(EnumPermissions.LAPORAN_CATALOG_CUSTOMER);
        },
        canAccessLaporanTugasAdmin() {
            return this.hasPermission(EnumPermissions.LAPORAN_TUGAS_ADMIN);
        },
        canAccessLaporanKirimBalikPGI() {
            return this.hasPermission(EnumPermissions.LAPORAN_KIRIM_BALIK_PGI);
        },
        canAccessLaporanKirimInvenPGI() {
            return this.hasPermission(EnumPermissions.LAPORAN_KIRIM_INVEN_PGI);
        },
        canAccessLaporanAdjustmentBarcode() {
            return this.hasPermission(EnumPermissions.LAPORAN_ADJUSTMENT_BARCODE);
        },
        canAccessLaporanAdjustmentKerusakan() {
            return this.hasPermission(EnumPermissions.LAPORAN_ADJUSTMENT_KERUSAKAN);
        },
        canAccessLaporanTitipJual() {
            return this.hasPermission(EnumPermissions.LAPORAN_TITIP_JUAL);
        },
        canAccessLaporanPenjualanMarketplace() {
            return this.hasPermission(EnumPermissions.LAPORAN_PENJUALAN_MARKETPLACE);
        },
        canAccessLaporanReturMarketplace() {
            return this.hasPermission(EnumPermissions.LAPORAN_MARKETPLACE_RETUR);
        },
        canAccessLaporanSalesAndReturnMarketplace() {
            return this.hasPermission(EnumPermissions.LAPORAN_SALES_RETUR_MARKETPLACE);
        },
        canAccessLaporanInventoryReset() {
            return this.hasPermission(EnumPermissions.LAPORAN_INVENTORY_RESET);
        },
        canAccessLaporanTemuanElektronik() {
            return this.hasPermission(EnumPermissions.LAPORAN_TEMUAN_ELEKTRONIK);
        },

        // Laporan Emas
        canAccessLaporanPenerimaanBarangEmasPGI() {
            return this.hasPermission(EnumPermissions.LAPORAN_PENERIMAAN_BARANG_EMAS_PGI);
        },
        canAccessLaporanPenerimaanBarangEmasPEI() {
            return this.hasPermission(EnumPermissions.LAPORAN_PENERIMAAN_BARANG_EMAS_PEI);
        },
        canAccessLaporanPenerimaanBarangEmasRBE() {
            return this.hasPermission(EnumPermissions.LAPORAN_PENERIMAAN_BARANG_EMAS_RBE);
        },
        canAccessLaporanPenerimaanBarangExternalEmas() {
            return this.hasPermission(EnumPermissions.LAPORAN_PENERIMAAN_BARANG_EXTERNAL_EMAS);
        },
        canAccessLaporanSalesReturEmas() {
            return this.hasPermission(EnumPermissions.LAPORAN_SALES_RETUR_EMAS);
        },
        canAccessLaporanSalesGoldDifference() {
            return this.hasPermission(EnumPermissions.LAPORAN_SALES_SELISIH_EMAS);
        },
        canAccessLaporanLeburEmas() {
            return this.hasPermission(EnumPermissions.LAPORAN_LEBUR_EMAS);
        },
        canAccessLaporanTemuanEmas() {
            return this.hasPermission(EnumPermissions.LAPORAN_TEMUAN_EMAS);
        },

        // Laporan Audit
        canAccessLaporanSalesAudit() {
            return this.hasPermission(EnumPermissions.LAPORAN_SALES_AUDIT);
        },
        canAccessLaporanSalesAuditEmas() {
            return this.hasPermission(EnumPermissions.LAPORAN_SALES_AUDIT_EMAS);
        },

        // Laporan Stok Gudang
        canAccessLaporanStockWarehouse() {
            return this.hasPermission(EnumPermissions.LAPORAN_STOCK_WAREHOUSE);
        },
    },
    methods: {
        hasPermission(permissionId) {
            return (
                this.$helper.checkRoleNumber(
                    permissionId.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },

        generateReportSales() {

            this.modalTitle = "Laporan Sales"

            if (this.inputSales.start == "" || this.inputSales.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.inputSales.start,
                end: this.inputSales.end,
                date_type: this.inputSales.dateType
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sales", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateReportTitipJual() {

            this.modalTitle = "Laporan Titip Jual"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/consignment", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateReportSalesMarketplace() {

            this.modalTitle = "Laporan Sales Marketplace"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sales-marketplace", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        generateReportSalesMarketplaceReturn() {
            this.modalTitle = "Laporan Retur Marketplace"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sales-marketplace-return", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = res.data.data.path
            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

         generateReportSalesAndReturnMarketplace() {
            this.modalTitle = "Laporan Sales & Retur Marketplace"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sales-return-marketplace", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = res.data.data.path
            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },



        generateReportSalesGold() {

            this.modalTitle = "Laporan Sales Emas"

            if (this.inputSales.start == "" || this.inputSales.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.inputSales.start,
                end: this.inputSales.end,
                date_type: this.inputSales.dateType
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sales-gold", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },


        generateReportReturn() {

            this.modalTitle = "Laporan Retur Barang"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/return", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateReportTransaction() {

            this.modalTitle = "Laporan Transaksi Customer"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/transactions", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },
        generateReportTransactionPayment() {
            this.modalTitle = "Laporan Transaksi Pembayaran"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/transaction-payment", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        generateDeliveryReport() {

            this.modalTitle = "Laporan Penerimaan Barang"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/delivery", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },
        generateDeliveryReportGold(type) {
            this.modalTitle = "Laporan Penerimaan Barang Emas " + type
            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end,
                type_report: type
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/delivery-gold", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
            .catch(error => {
                this.status = -1
                this.$helper.parseError(this, error)
            })

        },

        generateMovementReport() {

            this.modalTitle = "Laporan Perpindahan Barang"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/movement", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateCatalogCustomerLoginReport() {

            this.modalTitle = "Laporan Catalog Customer"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/catalog-customer", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateAdminTaskCountReport() {

            this.modalTitle = "Laporan Tugas Admin"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/admin-task", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateInventoryReturnReport() {

            this.modalTitle = "Laporan Kirim Balik PGI"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/inventory-return", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateInventoryExternal() {

            this.modalTitle = "Laporan Penerimaan Barang External"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end,
                type_report : "EXT"
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/delivery", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },
        generateInventoryGoldExternal() {

            this.modalTitle = "Laporan Penerimaan Barang Emas External"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end,
                type_report : "EXT"
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/delivery-gold", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateInventoryReport() {

            this.modalTitle = "Laporan Kirim Inventaris"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sendback", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },
        generateAdjustmentBarcodeReport() {
            this.modalTitle = "Laporan Adjustment Barcode"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/barcode-adjust-history", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

                })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },
        generateDamageAdjustmentReport() {
            this.modalTitle = "Laporan Adjustment Kerusakan"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/adjustment", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = this.$BASE_FILE_PATH + res.data.data.path

                })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        generateSalesAuditReport() {
            this.modalTitle = "Laporan Sales Audit"

            if (this.inputAudit.monthYear == "") {
                return this.$helper.toastError(this, "Mohon lengkapi bulan dan tahun laporan!")
            }

            const [year, month] = this.inputAudit.monthYear.split('-')

            let payload = {
                month: parseInt(month),
                year: parseInt(year)
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sales-audit", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = res.data.data.path

                })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        generateSalesAuditGoldReport() {
            this.modalTitle = "Laporan Sales Audit Emas"

            if (this.inputAudit.monthYear == "") {
                return this.$helper.toastError(this, "Mohon lengkapi bulan dan tahun laporan!")
            }

            const [year, month] = this.inputAudit.monthYear.split('-')

            let payload = {
                month: parseInt(month),
                year: parseInt(year)
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sales-audit-gold", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = res.data.data.path

                })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        generateWarehouseStock() {
            this.modalTitle = "Laporan Stok Gudang"

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/stock-warehouse", { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
            .catch(error => {
                this.status = -1
                this.$helper.parseError(this, error)
            })

        },
        generateReportDifferenceGoldSale() {
            this.modalTitle = "Laporan Penjualan Selisih Emas";
            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!");
            }
            let payload = {
                start: this.input.start,
                end: this.input.end
            };
            this.$bvModal.show("m-download");
            this.status = 0;
            this.$axios.post("report/sale-difference-gold", payload, { timeout: 600000 }).then(res => {
                this.status = 1;
                this.path = res.data.data.path;
            })
            .catch(error => {
                this.status = -1;
                this.$helper.parseError(this, error);
            });
        },
        generateInventoryResetReport() {
            this.modalTitle = "Laporan Inventory Reset"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/inventory-reset", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = res.data.data.path
            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },
        generateDateRangeReport(title, url) {
            this.modalTitle = title;

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!");
            }

            this.$bvModal.show("m-download");
            this.status = 0;
            this.$axios
                .post(url, { start: this.input.start, end: this.input.end }, { timeout: 600000 })
                .then(res => {
                    this.status = 1;
                    this.path = res.data.data.path;
                })
                .catch(error => {
                    this.status = -1;
                    this.$helper.parseError(this, error);
                });
        },
        generateGoldMeltReport() {
            this.modalTitle = "Laporan Lebur Emas"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/gold-process", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = res.data.data.path
            })
            .catch(error => {
                this.status = -1
                this.$helper.parseError(this, error)
            })
        },
    }
}
</script>

<style scoped>
.button-gold {
    background-color: #F3C623;
    color: black;
}

.divider {
    border-top: 1px solid #000;
    margin: 20px 0;
}
</style>
